import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'total',
  standalone: false
})
export class TotalPipe implements PipeTransform {

  transform(value: any, key?: string): any {
    let amount = 0;
    value.forEach(ele => { amount += ele[key]; });
    return amount;
  }

}
